import { Component, h} from 'preact'
import InputGroup from '../../control-components/ui-components/InputGroup'

interface Props {
  title: string,
  amount: number,
  onChange: (state: {title: string, amount: number}) => void
}

interface State {
  title: string,
  amount: number
}

export class TagCloud extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      title: props.title,
      amount: props.amount
    }

    this.onChangeTitle = this.onChangeTitle.bind(this)
    this.onChangeAmount = this.onChangeAmount.bind(this)
    this.notifyChanges = this.notifyChanges.bind(this)
  }

  onChangeTitle (newTitle: string) {
    this.setState({ title: newTitle }, this.notifyChanges)
  }

  onChangeAmount (newAmount: number) {
    this.setState({ amount: newAmount }, this.notifyChanges)
  }

  notifyChanges () {
    this.props.onChange({ title: this.state.title, amount: this.state.amount })
  }

  render (_ : Props, { title, amount }: State) {
    return (
      <div>
        <InputGroup
          title='Title'
          type='text'
          onChange={(e: ChangeEvent) => { this.onChangeTitle(e.target.value) }}
          value={title} />
        <InputGroup
          title='Amount'
          type='number'
          min={0}
          onChange={(e: ChangeEvent) => { this.onChangeAmount(parseInt(e.target.value)) }}
          value={amount} />
      </div>
    )
  }
}

export default TagCloud
